var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"card-handler",class:("animation-direction-" + _vm.animationDirection + "\n    " + (_vm.animateSoft ? 'animate-soft' : ''))},[_c('transition',{attrs:{"name":"move"}},_vm._l((_vm.filteredItems),function(ref){
    var data = ref.data;
    var index = ref.index;
return _c('li',{key:index,staticClass:"card-handler-child",attrs:{"data-index":index}},[_vm._t("default",null,{"data":data,"index":index})],2)}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }